import { TERMS_HERO_IMAGE_CLASS } from './terms.constants'

const HERO_IMG_STYLE =
  'max-width:100%;width:100%;display:block;object-fit:contain;object-position:top center;'

const INLINE_IMG_STYLE = 'max-width:100%;width:100%;height:auto;display:block;object-fit:contain;'

const stripSizeFromStyle = (style: string) =>
  style
    .replace(
      /(?:^|;)\s*(?:width|height|min-width|max-width|min-height|max-height)\s*:[^;]+;?/gi,
      ';'
    )
    .replace(/;+/g, ';')
    .replace(/^;|;$/g, '')
    .trim()

const mergeClassAttr = (attrs: string, className: string) => {
  const classMatch = attrs.match(/class=(["'])([\s\S]*?)\1/i)

  if (classMatch) {
    const existing = classMatch[2].trim()

    const merged = existing.split(/\s+/).includes(className)
      ? existing
      : `${existing} ${className}`.trim()

    return attrs.replace(/class=(["'])([\s\S]*?)\1/i, `class="${merged}"`)
  }

  return `${attrs} class="${className}"`
}

const applyImgStyle = (attrs: string, style: string) => {
  const styleMatch = attrs.match(/style=(["'])([\s\S]*?)\1/i)

  if (styleMatch) {
    const merged = [stripSizeFromStyle(styleMatch[2]), style].filter(Boolean).join(';')

    return attrs.replace(/style=(["'])([\s\S]*?)\1/i, `style="${merged}"`)
  }

  return `${attrs} style="${style}"`
}

/**
 * TipTap/backoffice HTML often ships fixed pixel widths on <img>, which overflow in modals.
 * The first image is marked as a hero block; height is controlled by CSS (60vh).
 */
export const normalizeTermsDescriptionHtml = (html: string) => {
  if (!html?.trim()) return html

  let imageIndex = 0

  return html.replace(/<img\b([^>]*?)\/?>/gi, (_match, attrs: string) => {
    imageIndex += 1

    const isHeroImage = imageIndex === 1

    let cleanAttrs = attrs
      .replace(/\s(width|height)=["'][^"']*["']/gi, '')
      .replace(/\s(width|height)=\S+/gi, '')

    if (isHeroImage) {
      cleanAttrs = mergeClassAttr(cleanAttrs, TERMS_HERO_IMAGE_CLASS)

      cleanAttrs = applyImgStyle(cleanAttrs, HERO_IMG_STYLE)
    } else {
      cleanAttrs = applyImgStyle(cleanAttrs, INLINE_IMG_STYLE)
    }

    return `<img${cleanAttrs} />`
  })
}
